// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "modal__root-2oWYI";
var _4 = "wrapper-1A-BY";
var _5 = "content-Nf2QA";
var _6 = "header-3uUi_";
var _7 = "footer_row-1GFAy";
var _8 = "footer_buttons_row-3OUos";
var _9 = "footer_root-1-MOG";
var _a = "footer_confirm_btn-3spYn";
var _b = "footer_cancel_btn-108X1";
var _c = "button_empty-1hIZh";
var _d = "mobile_row-3Zn1a";
export { _1 as "__esModule", _2 as "mobile", _3 as "modal__root", _4 as "wrapper", _5 as "content", _6 as "header", _7 as "footer_row", _8 as "footer_buttons_row", _9 as "footer_root", _a as "footer_confirm_btn", _b as "footer_cancel_btn", _c as "button_empty", _d as "mobile_row" }
export default { "__esModule": _1, "mobile": _2, "modal__root": _3, "wrapper": _4, "content": _5, "header": _6, "footer_row": _7, "footer_buttons_row": _8, "footer_root": _9, "footer_confirm_btn": _a, "footer_cancel_btn": _b, "button_empty": _c, "mobile_row": _d }
